export default {
    install(Vue) {
        Vue.prototype.dealPermissions = function(permissions, roles, oneOfPermissions) {
            let permissionsShow = true;
            /* 权限字符串 拥有所有权限可显示 */
            for (let i = 0; i < permissions.length; i++) {
                let stringPermissionsList = sessionStorage.getItem('stringPermissions').split(',');
                let isContain = stringPermissionsList.find(function(value) {
                    if (value === permissions[i]) {
                        return true;
                    }
                });
                if (isContain === undefined) {
                    permissionsShow = false;
                    break;
                }
            }
            /* 角色 该角色用于可显示 */
            if (permissionsShow && roles.length > 0) {
                let rolesList = sessionStorage.getItem('roles').split(',');
                for (let j = 0; j < rolesList.length; j++) {
                    permissionsShow = false;
                    let isContain = roles.find(function(value) {
                        if (value === rolesList[j]) {
                            return true;
                        }
                    });
                    if (isContain) {
                        permissionsShow = true;
                        break;
                    }
                }
            }
            /* 拥有组件权限之一可显示 */
            if (permissionsShow && oneOfPermissions.length > 0) {
                let PermissionsList = sessionStorage.getItem('stringPermissions').split(',');
                for (let k = 0; k < PermissionsList.length; k++) {
                    permissionsShow = false;
                    let isContain = oneOfPermissions.find(function(value) {
                        if (value === PermissionsList[k]) {
                            return true;
                        }
                    });
                    if (isContain) {
                        permissionsShow = true;
                        break;
                    }
                }
            }
            return permissionsShow;
        };
    }
};
